export default "__VITE_ASSET__Cwv7oA9n__"